import { render, staticRenderFns } from "./ReceiverDetail.vue?vue&type=template&id=6e0a425a&"
import script from "./ReceiverDetail.vue?vue&type=script&lang=ts&"
export * from "./ReceiverDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports